document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".newcalc");
  if (!container) return;

  const materialRadios = container.querySelectorAll('input[name="material"]');
  const areaInput = container.querySelector(
    ".newcalc__wrapper__col__square__value input"
  );
  const totalSpan = container.querySelector("#calc_result");
  const button = container.querySelector(".btn--theme--getoffer");

  function formatPrice(number) {
    return number.toLocaleString("ru");
  }

  function animateTotal(newTotal) {
    const currentTotal = parseInt(
      totalSpan.textContent.replace(/\s+/g, ""),
      10
    );
    if (currentTotal === newTotal) return;

    const direction = newTotal > currentTotal ? "increase" : "decrease";
    totalSpan.classList.remove("increase", "decrease");
    totalSpan.classList.add(direction);

    const duration = 500;
    const startTime = performance.now();

    function step(timestamp) {
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const interpolated = currentTotal + (newTotal - currentTotal) * progress;
      totalSpan.textContent = formatPrice(Math.round(interpolated));

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        totalSpan.classList.remove("increase", "decrease");
      }
    }

    requestAnimationFrame(step);
  }

  function calculateCost() {
    let materialValue = 0;
    const selectedMaterial = container.querySelector(
      'input[name="material"]:checked'
    );

    if (selectedMaterial) {
      materialValue = parseInt(selectedMaterial.value, 10);
    }

    const area = Math.min(
      Math.max(parseInt(areaInput.value, 10) || 0, 0),
      10000
    );
    let total = selectedMaterial && area > 0 ? materialValue * area : 8000;

    if (total < 8000) total = 8000;

    updateButtonData(selectedMaterial, area, total);
    animateTotal(total);
  }

  function updateButtonData(selectedMaterial, area, total) {
    if (!button) return;

    let materialLabel = "Не выбрано";
    if (selectedMaterial) {
      const label = container.querySelector(
        `label[for="${selectedMaterial.id}"]`
      );
      if (label) materialLabel = label.textContent.trim();
    }

    button.setAttribute("data-material", materialLabel);
    button.setAttribute("data-square", area.toString());
    button.setAttribute("data-totalcost", total.toString());
  }

  areaInput.addEventListener("input", () => {
    let value = parseInt(areaInput.value, 10) || 0;
    if (value > 10000) value = 10000;
    areaInput.value = value;
    calculateCost();
  });

  areaInput.addEventListener("paste", (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");
    const value = parseInt(pastedText, 10);
    if (value && value > 10000) {
      e.preventDefault();
      areaInput.value = 10000;
      calculateCost();
    }
  });

  materialRadios.forEach((radio) => {
    radio.addEventListener("change", calculateCost);
  });

  calculateCost();
});
